import { useMutation } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { PostTherapistInvitationArgs, PostTherapistInvitationResponse } from "../schemas/invitations";

export const usePostTherapistInvitation = () => {
  const client = useApiClient();

  return useMutation<PostTherapistInvitationResponse, Error, PostTherapistInvitationArgs>({
    mutationFn: args => client.postTherapistInvitation(args),
  });
};
